import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination, EffectCards} from 'swiper/modules';
import {getOptionsFromJsonString} from "../../../default/global/js/utilities/options";

export function initSlideshows(query = document.querySelectorAll('.slideshow.swiper')) {
    for (let slideshow of query) {
        let options = getOptionsFromJsonString(slideshow.dataset.options,{
            autoplay_interval: 5000,
            eff_interval: 300,
        });


        slideshow1(slideshow);
        window.addEventListener("resize" , function () {
            slideshow1(slideshow);
        });

        if(slideshow.classList.contains("slideshow--2")){
            Swiper.use([Autoplay, Navigation]);
            new Swiper(slideshow, {
                loop: true,
                items: 1,
                speed: options.eff_interval,
                autoplay: {
                    delay: options.autoplay_interval,
                },
                navigation: {
                    nextEl: slideshow.querySelector('.swiper-button-next'),
                    prevEl: slideshow.querySelector('.swiper-button-prev'),
                }
            });
        }
        if(slideshow.classList.contains("slideshow--3")){
            Swiper.use([Autoplay,Pagination]);
            new Swiper(slideshow, {
                loop: true,
                items: 1,
                speed: options.eff_interval,
                autoplay: {
                    delay: options.autoplay_interval,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                }
            });
        }
    }
}


function slideshow1(slideshow) {
    if(slideshow.classList.contains("slideshow--1")){

        //effect doesn't work for swiper breakpoints
        let params = {
            effect: "cards",
            grabCursor: true,
            loop: true,
            slideShadows: false,
            pagination: {
                el: '.categoryPreviewPaginationWrapper',
                clickable: true,
                renderBullet: function(index, className) {
                    let slides = slideshow.querySelectorAll(".banner");
                    let activeClass = "";
                    if(index == slides.length - 1) {
                        activeClass = "pagActive";
                    }
                    let html = "<div class='categoryPreviewPagination " + activeClass + "' data-index='" + index + "'>";
                    let banner = slides[index];
                    html += "<a href='" + banner.dataset.link + "'>" + banner.dataset.name + "</a>";
                    html += '</div>';
                    return html;
                }
            }
        };
        let newInit = false;
        if(!slideshow.classList.contains("swiper-initialized")) {
            newInit = true;
        }
        if(window.innerWidth <= 1024 || window.outerWidth <= 1024) {
            if(slideshow.classList.contains("slideshow--1-desktop")) {
                newInit = true;
                slideshow.classList.remove("slideshow--1-desktop");
                let oldSlider = slideshow.swiper;
                if(oldSlider) {
                    oldSlider.destroy(true, true);
                }
            }
            slideshow.classList.add("slideshow--1-mobile");
            params = {
                loop: true,
                slidesPerView: 1.1,
                spaceBetween: 10
            };
        } else {
            if(slideshow.classList.contains("slideshow--1-mobile")) {
                newInit = true;
                slideshow.classList.remove("slideshow--1-mobile");
                let oldSlider = slideshow.swiper;
                if(oldSlider) {
                    oldSlider.destroy(true, true);
                }
            }
            slideshow.classList.add("slideshow--1-desktop");
        }

        if(newInit) {
            Swiper.use([EffectCards, Pagination]);
            const categoryPreview = new Swiper(slideshow, params);

            let paginations = document.querySelectorAll(".categoryPreviewPagination");
            for(let pagination of paginations) {
                let index = pagination.dataset.index;
                pagination.addEventListener("mouseover", function () {
                    categoryPreview.slideTo(index);
                    for(let pag of paginations) {
                        pag.classList.remove("pagActive");
                    }
                    pagination.classList.add("pagActive");
                });
            }

            categoryPreview.on("slideChange",function () {
                let paginations = document.querySelectorAll(".categoryPreviewPagination");
                let activeSlide = document.querySelector(".categoryPreview .swiper-slide-active");
                let activeIndex = activeSlide.dataset.swiperSlideIndex;
                if(activeIndex == 0) {
                    activeIndex = paginations.length - 1;
                } else {
                    activeIndex -= 1;
                }
                for(let pagination of paginations) {
                    let index = pagination.dataset.index;
                    pagination.classList.remove("pagActive");
                    if(index == activeIndex) {
                        pagination.classList.add("pagActive");
                    }
                }
            });
        }

    }
}
